import * as React from 'react';
import type { SVGProps } from 'react';
const SvgChemicalBottle = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M10.5 5A.75.75 0 0 0 9 5zM15 5a.75.75 0 0 0-1.5 0zm.466 8.196-.636.397zm3.784 6.054V20a.75.75 0 0 0 .636-1.148zm-14.5 0-.636-.398A.75.75 0 0 0 4.75 20zm3.784-6.054.636.397zM9 5v3.956h1.5V5zm6 3.956V5h-1.5v3.956zm-.17 4.637 3.784 6.055 1.272-.796-3.784-6.054zm4.42 4.907H4.75V20h14.5zM5.386 19.648l3.784-6.055-1.272-.795-3.784 6.054zM13.5 8.956c0 1.64.46 3.247 1.33 4.637l1.272-.795A7.25 7.25 0 0 1 15 8.956zm-4.5 0a7.25 7.25 0 0 1-1.102 3.842l1.272.795a8.75 8.75 0 0 0 1.33-4.637z"
    />
    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M6.75 4.75h10.5" />
  </svg>
);
export default SvgChemicalBottle;
